const casos = [
    {
        id:3,
        items:[
           
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/2.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-0/2.png`,
                id:'53',
                index:'102',
            },
            {
                res:true,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/11.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-3/3.png`,
                id:'62',
                index:'103',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/4.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-1/1.png`,
                id:'55',
                index:'101',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/17.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/5.png`,
                id:'68',
                index:'105',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/13.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/1.png`,
                id:'64',
                index:'101',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/6.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-2/1.png`,
                id:'57',
                index:'101',
            },
           
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/8.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-2/3.png`,
                id:'59',
                index:'103',
            },
           
            {
                res:true,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/10.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-3/2.png`,
                id:'61',
                index:'102',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/15.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/3.png`,
                id:'66',
                index:'103',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/5.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-1/2.png`,
                id:'56',
                index:'102',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/3.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-0/3.png`,
                id:'54',
                index:'103',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/7.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-2/2.png`,
                id:'58',
                index:'102',
            },
            {
                res:true,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/12.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-3/4.png`,
                id:'63',
                index:'104',
            },
           
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/14.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/2.png`,
                id:'65',
                index:'102',
            },
           
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/16.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/4.png`,
                id:'67',
                index:'104',
            },
            {
                res:true,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/9.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-3/1.png`,
                id:'60',
                index:'101',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/1.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-0/1.png`,
                id:'52',
                index:'1',
            },

        ],
        exito:'¿En tu casa compartes con hermanos o hermanas que tienen otra mamá o papá? Si es así, esa es tu familia, considerada por la Corte Constitucional como aquella comunidad de personas emparentadas entre sí por vínculos naturales o jurídicos, que funda su existencia en el amor, el respeto y la solidaridad, y que se caracteriza por la unidad de vida o de destino que liga íntimamente a sus integrantes más próximos.',
        fracaso:'Prueba con otra figura',
        mascota:{image:`${process.env.PUBLIC_URL}/assets/gato.png`, x:10, reflected:false, visible:false}
    },
    
    {
        id:1,
        items:[
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/17.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/5.png`,
                id:'34',
                index:'105',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/2.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-0/2.png`,
                id:'19',
                index:'102',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/12.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-3/4.png`,
                id:'29',
                index:'104',
            },
            
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/3.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-0/3.png`,
                id:'20',
                index:'103',
            },
            
            {
                res:true,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/5.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-1/2.png`,
                id:'22',
                index:'102',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/1.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-0/1.png`,
                id:'18',
                index:'101',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/6.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-2/1.png`,
                id:'23',
                index:'101',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/14.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/2.png`,
                id:'31',
                index:'102',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/15.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/3.png`,
                id:'32',
                index:'103',
            },
            
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/8.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-2/3.png`,
                id:'25',
                index:'103',
            },
            
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/10.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-3/2.png`,
                id:'27',
                index:'102',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/7.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-2/2.png`,
                id:'24',
                index:'102',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/11.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-3/3.png`,
                id:'28',
                index:'103',
            },
            
            {
                res:true,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/4.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-1/1.png`,
                id:'21',
                index:'101',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/13.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/1.png`,
                id:'30',
                index:'101',
            },
            
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/16.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/4.png`,
                id:'33',
                index:'104',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/9.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-3/1.png`,
                id:'26',
                index:'101',
            },
            

        ],
        exito:'¿Vives solo con tu papá o mamá y tus hermanos o hermanas, si tienes? Bueno, entonces esa es tu familia, considerada por la Corte Constitucional como aquella comunidad de personas emparentadas entre sí por vínculos naturales o jurídicos, que funda su existencia en el amor, el respeto y la solidaridad, y que se caracteriza por la unidad de vida o de destino que liga íntimamente a sus integrantes más próximos.',
        fracaso:'Prueba con otra figura',
        mascota:{image:`${process.env.PUBLIC_URL}/assets/gato.png`, x:10, reflected:true, visible:false}
    },
    {
        id:2,
        items:[
            
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/2.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-0/2.png`,
                id:'36',
                index:'102',
            },
            
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/15.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/3.png`,
                id:'49',
                index:'103',
            },
            {
                res:true,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/8.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-2/3.png`,
                id:'42',
                index:'103',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/4.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-1/1.png`,
                id:'38',
                index:'101',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/14.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/2.png`,
                id:'48',
                index:'102',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/12.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-3/4.png`,
                id:'46',
                index:'104',
            },
           
            {
                res:true,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/6.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-2/1.png`,
                id:'40',
                index:'101',
            },
           
           
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/9.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-3/1.png`,
                id:'43',
                index:'101',
            },
            
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/3.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-0/3.png`,
                id:'37',
                index:'103',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/5.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-1/2.png`,
                id:'39',
                index:'102',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/1.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-0/1.png`,
                id:'35',
                index:'1',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/10.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-3/2.png`,
                id:'44',
                index:'102',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/17.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/5.png`,
                id:'51',
                index:'105',
            },
            {
                res:true,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/7.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-2/2.png`,
                id:'41',
                index:'102',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/11.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-3/3.png`,
                id:'45',
                index:'103',
            },
            
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/13.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/1.png`,
                id:'47',
                index:'101',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/16.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/4.png`,
                id:'50',
                index:'104',
            },
           

        ],
        exito:'¿Vives en casa con dos mamás o dos papás, y tus hermanos y hermanas, si tienes? ¡Esa es tu familia!, considerada por la Corte Constitucional como aquella comunidad de personas emparentadas entre sí por vínculos naturales o jurídicos, que funda su existencia en el amor, el respeto y la solidaridad, y que se caracteriza por la unidad de vida o de destino que liga íntimamente a sus integrantes más próximos.',
        fracaso:'Prueba con otra figura',
        mascota:{image:`${process.env.PUBLIC_URL}/assets/perro.png`, x:15, reflected:false, visible:false}
    },
    
    {
        id:4,
        items:[
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/1.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-0/1.png`,
                id:'69',
                index:'1',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/5.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-1/2.png`,
                id:'72',
                index:'102',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/6.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-2/1.png`,
                id:'74',
                index:'101',
            },
           
            {
                res:true,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/16.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/4.png`,
                id:'84',
                index:'104',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/8.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-2/3.png`,
                id:'76',
                index:'103',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/2.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-0/2.png`,
                id:'70',
                index:'102',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/7.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-2/2.png`,
                id:'75',
                index:'102',
            },
            {
                res:true,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/15.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/3.png`,
                id:'83',
                index:'103',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/3.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-0/3.png`,
                id:'71',
                index:'103',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/11.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-3/3.png`,
                id:'79',
                index:'103',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/9.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-3/1.png`,
                id:'77',
                index:'101',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/4.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-1/1.png`,
                id:'72',
                index:'101',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/12.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-3/4.png`,
                id:'80',
                index:'104',
            },
            
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/10.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-3/2.png`,
                id:'78',
                index:'102',
            },
            {
                res:true,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/14.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/2.png`,
                id:'82',
                index:'102',
            },
           
            {
                res:true,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/17.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/5.png`,
                id:'85',
                index:'105',
            },
            {
                res:true,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/13.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/1.png`,
                id:'81',
                index:'101',
            },

        ],
        exito:'Si en tu hogar viven tu abuelo o abuela, tu papá o mamá, algunos primos y primas, tíos y tías u otra persona con la que tengas un lazo de consanguinidad, entonces todos ellos hacen parte de tu familia, considerada por la Corte Constitucional como aquella comunidad de personas emparentadas entre sí por vínculos naturales o jurídicos, que funda su existencia en el amor, el respeto y la solidaridad, y que se caracteriza por la unidad de vida o de destino que liga íntimamente a sus integrantes más próximos.',
        fracaso:'Prueba con otra figura',
        mascota:{image:`${process.env.PUBLIC_URL}/assets/perro.png`, x:20, reflected:false, visible:false}
    },
    {
        id:0,
        items:[
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/4.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-1/1.png`,
                id:'4',
                index:'101',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/9.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-3/1.png`,
                id:'9',
                index:'101',
            },
            {
                res:true,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/1.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-0/1.png`,
                id:'1',
                index:'101',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/5.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-1/2.png`,
                id:'5',
                index:'102',
            },
            {
                res:true,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/2.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-0/2.png`,
                id:'2',
                index:'102',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/10.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-3/2.png`,
                id:'10',
                index:'102',
            },
            {
                res:true,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/3.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-0/3.png`,
                id:'3',
                index:'103',
            },
           
           
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/6.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-2/1.png`,
                id:'6',
                index:'101',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/11.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-3/3.png`,
                id:'11',
                index:'103',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/16.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/4.png`,
                id:'16',
                index:'104',
            },
           
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/7.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-2/2.png`,
                id:'7',
                index:'102',
            },
           
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/12.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-3/4.png`,
                id:'12',
                index:'104',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/14.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/2.png`,
                id:'14',
                index:'102',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/8.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-2/3.png`,
                id:'8',
                index:'103',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/15.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/3.png`,
                id:'15',
                index:'103',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/17.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/5.png`,
                id:'17',
                index:'105',
            },
            {
                res:false,
                src:`${process.env.PUBLIC_URL}/assets/thumbs/13.png`,
                boardSrc:`${process.env.PUBLIC_URL}/assets/familia-4/1.png`,
                id:'13',
                index:'101',
            },

        ],
        exito:'Si en tu hogar viven tu papá, mamá, tú y tus hermanos o hermanas, si tienes, entonces esa es tu familia, considerada por la Corte Constitucional como aquella comunidad de personas emparentadas entre sí por vínculos naturales o jurídicos, que funda su existencia en el amor, el respeto y la solidaridad, y que se caracteriza por la unidad de vida o de destino que liga íntimamente a sus integrantes más próximos.',
        fracaso:'Prueba con otra figura',
        mascota:{image:`${process.env.PUBLIC_URL}/assets/perro.png`, x:20, reflected:false, visible:false}
    },
]

export default casos;